import React, { useState, useEffect } from "react";
/*import '../Assets/Styles/addNewCarPopup.css';*/
//import car from '../Assets/Images/car.jpg'
//import "../Assets/Styles/carImages.css";
//import pencil from "../Assets/Images/pencil.svg"
//import upload from "../Assets/Images/upload.svg"
import sideImage from "../../asstes/images/add-car-left.svg";
import carIcon from "../../asstes/images/car-icon.svg";
import { Heading, Img, Button, Text, Switch } from "../../components";
import CarDetails from "components/CarDetails";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Alert from "../Alert";
import AccesoriesCheckList from '../AccesoriesCheckList';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { he } from "date-fns/locale";import { API_DOMAIN_IMG, API_DOMAIN } from "config";
/** ➋ קומפוננטת שדה-טופס קטנה (אפשר לשים בקובץ נפרד) */
import SendNewOfferColumncar10660x from "../../components/SendNewOfferColumncar10660x";
import CarCard from "components/CarCard";
import "react-datepicker/dist/react-datepicker.css";
import CarCardTemplate from "components/CarCardTemplate";
import  "../../styles/add-new-car.css";
import "react-datepicker/dist/react-datepicker.css";
import CarSummaryPreview from "components/CarSummaryPreview.jsx"; 
import AuctionFormFields from "../AuctionFormFields";
registerLocale("he", he);
setDefaultLocale("he");

// const Field = ({
//   name,
//   label,
//   icon,
//   type = "text",
//   value,
//   onChange,
//   onBlur,
// }) => (
//   <div className="wrp-car-field">
//     <div className="label-wrap">
//       {icon && <img src={icon} alt="" />}
//       <label htmlFor={name}>{label}</label>
//     </div>
//     <input
//       id={name}
//       name={name}
//       type={type}
//       value={value} // ← חובה!
//       onChange={onChange}
//       onBlur={onBlur}
//       className="border rounded px-2 py-1 focus:outline-none focus:border-blue-500"
//     />
//   </div>
// );
const isTruthy = (v) => v === true || v === 1 || v === "1" || v === "true";

const MOT_ACC_MAP = [
  { id: "abs",             keys: ["Abs", "ABS"] },
  { id: "belt-sensors",    keys: ["BeltSensors"] },
  { id: "magnesium-wheel", keys: ["GalgalMagnezium", "MagnesiumWheels"] },
  { id: "camera",          keys: ["ReverseCamera", "Camera"] },
  { id: "top-window",      keys: ["Sunroof", "TopWindow", "HalonBagag"] },
  { id: "air-conditioner", keys: ["AirConditioner", "AirConditioning", "Mazgan"] },
  { id: "electric-windows",keys: ["ElectricWindows", "WindowsElectric", "HalonotHashmal"] },
  { id: "electric-mirror", keys: ["ElectricMirrors", "MirrorsElectric", "MirotHashmal"] },
  { id: "power-steering",  keys: ["PowerSteering", "HegaKoach", "HegaKoah"] },
  { id: "sound-system",    keys: ["SoundSystem", "AudioSystem", "MaarahatShma"] },
  { id: "multimedia",      keys: ["Multimedia", "MultimediaSystem", "MaarahatMultimedia"] },
  { id: "mobilai",         keys: ["Mobileye", "Mobilai", "MOBILEYE"] },
  { id: "upholstery",      keys: ["Upholstery", "Rifud", "Rivud"] },
  { id: "hands-free",      keys: ["HandsFree", "Bluetooth", "Diburit"] },
];

const mapAccessoriesFromMot = (cd) => {
  if (!cd) return [];
  return MOT_ACC_MAP
    .filter(({ keys }) => keys.some((k) => isTruthy(cd?.[k]) || (typeof cd?.[k] === "string" && cd[k].trim())))
    .map(({ id }) => id);
};

const Field = React.memo(({
  name,
  label,
  icon,
  type = "text",
  value,
  onChange,
  onBlur,
}) => {
  return (
        <div className="wrp-car-field">
          <div className="label-wrap">
            {icon && <img src={icon} alt="" />}
            <label htmlFor={name}>{label}</label>
          </div>
    
          {type === "date" ? (
           <DatePicker
           withPortal
    selected={value}
    onChange={onChange}
    onBlur={onBlur}
    locale="he"                  // מעביר לו את האובייקט העברי
    dateFormat="dd/MM/yyyy"
    popperPlacement="bottom-end" // פקודת מיקום
    popperContainer={({ children }) => (
      <div style={{
        position: "absolute",
        zIndex: 10000,
        overflow: "visible"      // כדי שלא ייחתך
      }}>
        {children}
      </div>
    )}
    showPopperArrow={false}      // אם אין צורך בחץ הקטן
    className="order rounded px-2 py-1 focus:outline-none focus:border-blue-500"
    id={name}
    onChangeRaw={e => e.preventDefault()} // מונע הקלדה
  />
          ) : (
            <input
              id={name}
              name={name}
              type={type}
              value={value?.toString() ?? ""}
              onChange={onChange}
              onBlur={onBlur}
              className="border rounded px-2 py-1 focus:outline-none focus:border-blue-500"
            />
          )}
        </div>
      );
});


function AddNewCar({ onClose, currentUser }) {

  const navigate = useNavigate();
const [activeTab, setActiveTab] = useState(1);
  const [index, setIndex] = useState(1);
  const [form, setForm] = useState({
    saleTypes: [], // במקום saleType: ""
    price: "",
  });

  const [car, setCar] = useState({
    user_id: currentUser?.id,
    license_plate: "",
    year: "",
    manufacturer: "",
    model: "",
    sub_model: "",
    accident_type: "",
    damage_estimate: "",
    asking_price: "",
    status: 1,
    transmission: "",
    hand: "",    
    car_type: "",
    kilometer: "",
    gearbox: "",
    original_ownership: "",
    annual_registration_fee: "",
    finish_level: "",
    engine_capacity: "",
    engine_type: "",
    chassis_number: "",
    accessories: "",
    entry_date: "",
    pickup_date: "",
    last_payment_date: "",    
    color: "",
    engine_number: "",
    insert_date: "",
    is_auction: false,
    auction_start_datetime: null,
    sale_type_id: null,
  });  

  const [images, setImages] = useState([]);
  const [videoFile, setVideoFile] = useState(null);
  //const [entryDate, setEntryDate] = useState(new Date());
  const MAX_VIDEO_SIZE_MB = 10;
  const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/svg+xml"];
const MAX_IMAGE_SIZE_KB = 150;
const MAX_IMAGE_SIZE_BYTES_IMG = MAX_IMAGE_SIZE_KB * 1024;
const MAX_IMAGES = 20;
const ALLOWED_VIDEO_TYPES = [
  "video/mp4",
  "video/quicktime",      // mov
  "video/x-m4v",
  "video/avi",
  "video/x-msvideo",      // avi
  "video/mpeg",           // mpeg
];

const [isDraggingVideo, setIsDraggingVideo] = useState(false);

const [isDragging, setIsDragging] = useState(false);
const [rotatingIndexes, setRotatingIndexes] = useState([]);
const [draggingImageIndex, setDraggingImageIndex] = useState(null);

const loadImageElement = (source) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("טעינת התמונה נכשלה"));
    img.src = source;
  });

const canvasToBlob = (canvas, mimeType) =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("יצירת קובץ מסובב נכשלה"));
        return;
      }
      resolve(blob);
    }, mimeType);
  });

async function rotateFile90(file) {
  const objectUrl = URL.createObjectURL(file);

  try {
    const img = await loadImageElement(objectUrl);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("לא ניתן לסובב את התמונה");
    }

    canvas.width = img.height;
    canvas.height = img.width;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(Math.PI / 2);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    const outputType = file.type === "image/svg+xml" ? "image/png" : (file.type || "image/jpeg");
    const rotatedBlob = await canvasToBlob(canvas, outputType);
    const rotatedName = file.name?.replace(/(\.[^.]+)?$/, "") || "rotated-image";
    const extension = outputType === "image/png" ? ".png" : (file.name.match(/\.[^.]+$/)?.[0] || ".jpg");

    return new File([rotatedBlob], `${rotatedName}-rotated${extension}`, {
      type: outputType,
      lastModified: Date.now(),
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

const handleRotateImage = async (indexToRotate) => {
  const imageToRotate = images[indexToRotate];
  if (!(imageToRotate instanceof File)) return;

  setRotatingIndexes((prev) => [...prev, indexToRotate]);
  setShowAlert(false);

  try {
    const rotated = await rotateFile90(imageToRotate);
    setImages((prev) => prev.map((img, i) => (i === indexToRotate ? rotated : img)));
  } catch (err) {
    console.error(err);
    setAlertMessage("לא הצלחנו לסובב את התמונה. נסה שוב.");
    setAlertType("error");
    setShowAlert(true);
  } finally {
    setRotatingIndexes((prev) => prev.filter((i) => i !== indexToRotate));
  }
};

// מעבד קבצי תמונה (גם מ-input וגם מ-drop)
function processImageFiles(fileList) {
  setShowAlert(false);

  const incoming = Array.from(fileList || []);
  const valid = [];
  const errors = [];

  for (const f of incoming) {

    
    valid.push(f);
  }

  if (valid.length === 0 && errors.length) {
    setAlertMessage(errors.join("\n"));
    setAlertType("error");
    setShowAlert(true);
    return;
  }

  setImages(prev => {
    const room = Math.max(0, MAX_IMAGES - prev.length);
    const toAdd = valid.slice(0, room);
    if (toAdd.length < valid.length) {
      errors.push(`נבחרו יותר מ-${MAX_IMAGES} תמונות. נוספו רק הראשונות עד להשלמת ${MAX_IMAGES}.`);
    }
    const next = [...prev, ...toAdd];
    if (errors.length) {
      setAlertMessage(errors.join("\n"));
      setAlertType("error");
      setShowAlert(true);
    }
    return next;
  });
}

function handleFileChange(e) {
  processImageFiles(e.target.files);
  // איפוס כדי שהעלאה זהה שוב תטריג onChange
  e.target.value = "";
}

// Drag & Drop
function handleDragOver(e) {
  e.preventDefault();
  e.stopPropagation();
  e.dataTransfer.dropEffect = "copy";
  setIsDragging(true);
}

function handleDragEnter(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDragging(true);
}

function handleDragLeave(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDragging(false);
}

function handleDrop(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDragging(false);
  const dt = e.dataTransfer;
  if (!dt) return;
  processImageFiles(dt.files);
}

  const handleDelete = (indexToDelete) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== indexToDelete));
  };

  const handleImageDragStart = (index) => {
    setDraggingImageIndex(index);
  };

  const handleImageDropReorder = (targetIndex) => {
    setImages((prev) => {
      if (draggingImageIndex === null || draggingImageIndex === targetIndex) {
        return prev;
      }

      const next = [...prev];
      const [moved] = next.splice(draggingImageIndex, 1);
      next.splice(targetIndex, 0, moved);
      return next;
    });
    setDraggingImageIndex(null);
  };

  const handleImageDragEnd = () => {
    setDraggingImageIndex(null);
  };

  const handleSetAsPrimaryImage = (indexToPromote) => {
    setImages((prev) => {
      if (indexToPromote <= 0 || indexToPromote >= prev.length) return prev;
      const next = [...prev];
      const [picked] = next.splice(indexToPromote, 1);
      next.unshift(picked);
      return next;
    });
  };








  function processVideoFiles(fileList) {
  setShowAlert(false);

  const files = Array.from(fileList || []);
  if (!files.length) return;

  const errors = [];
  // לוקחים רק קובץ אחד
  const file = files[0];

  if (!ALLOWED_VIDEO_TYPES.includes(file.type)) {
    errors.push("סוג הווידאו אינו נתמך. מותר: MP4, MOV, AVI, MPEG.");
  }
  if (file.size > MAX_VIDEO_SIZE_BYTES) {
    errors.push(`הקובץ גדול מדי. מקסימום מותר: ${MAX_VIDEO_SIZE_MB}MB.`);
  }

  if (errors.length) {
    setAlertMessage(errors.join("\n"));
    setAlertType("error");
    setShowAlert(true);
    return;
  }

  setVideoFile(file);

  // אם היו יותר מקובץ אחד – נודיע שמטפלים רק בראשון
  if (files.length > 1) {
    setAlertMessage("נבחרו מספר קבצים, הועלה רק הראשון.");
    setAlertType("error");
    setShowAlert(true);
  }
}

function handleVideoChange(e) {
  processVideoFiles(e.target.files);
  e.target.value = "";
}

function handleVideoDragOver(e) {
  e.preventDefault();
  e.stopPropagation();
  e.dataTransfer.dropEffect = "copy";
  setIsDraggingVideo(true);
}

function handleVideoDragEnter(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDraggingVideo(true);
}

function handleVideoDragLeave(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDraggingVideo(false);
}

function handleVideoDrop(e) {
  e.preventDefault();
  e.stopPropagation();
  setIsDraggingVideo(false);
  const dt = e.dataTransfer;
  if (!dt) return;
  processVideoFiles(dt.files);
}

function removeVideo() {
  setVideoFile(null);
}

const RotateIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
    <path
      d="M20 11a8 8 0 1 1-2.34-5.66L20 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 4v4h-4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DragHandleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
    <path d="M8 5v14M12 5v14M16 5v14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);



  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("error"); // default error

  const toggleSaleType = (type) => {
    const id = type === "unload" ? 1 : 2; // לפי טבלת `car_sale_types`
    setCar((prev) => ({
      ...prev,
      sale_type_id: id,
    }));
    setForm((prev) => ({
      ...prev,
      saleTypes: [type],
    }));
  };

const getPreviewAuctionFields = () => {
  if (!car?.is_auction) {
    return {
      is_auction: 0,
      auction_status: car?.auction_status,
      auction_is_active: 0,
      auction_has_started: 0,
    };
  }

  const auctionStartDateTime =
    auctionStartDate && auctionStartTime
      ? `${auctionStartDate} ${auctionStartTime}:00`
      : car.auction_start_datetime;
  const startMs = auctionStartDateTime
    ? new Date(String(auctionStartDateTime).replace(" ", "T")).getTime()
    : 0;
  const hasStarted = Number.isFinite(startMs) && startMs > 0 && startMs <= Date.now();

  return {
    is_auction: 1,
    auction_start_datetime: auctionStartDateTime,
    auction_status: hasStarted ? "active" : "future",
    auction_is_active: hasStarted ? 1 : 0,
    auction_has_started: hasStarted ? 1 : 0,
    has_started: hasStarted,
  };
};

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // ✅ בדיקת תקינות שדות מכרז (אם נבחר)
    if (car.is_auction) {
      const errors = {};
      if (!auctionStartDate) errors.auctionStartDate = "יש לבחור תאריך התחלה";
      if (!auctionStartTime) errors.auctionStartTime = "יש לבחור שעת התחלה";
      if (Object.keys(errors).length) {
        setAuctionErrors(errors);
        setAlertMessage("יש לבחור תאריך ושעת התחלה למכרז");
        setAlertType("error");
        setShowAlert(true);
        return;
      }
    }

    // ✅ זה הפיילואד שאת באמת רוצה לשלוח (במקום fullCar / carPayload לא מוגדר)
    const carPayload = {
      ...car,
      accessories: selected, // האביזרים מהצ'קליסט
    };

    // צרף את שדה תאריך+שעה למכרז במידה ונבחר מכרז
    if (car.is_auction) {
      // expected format: YYYY-MM-DD HH:MM:SS
      carPayload.auction_start_datetime = `${auctionStartDate} ${auctionStartTime}:00`;
    } else {
      carPayload.auction_start_datetime = null;
    }

    // ✅ 1) שמירת רכב (JSON בלבד)
    const { data } = await axios.post(`${API_DOMAIN}/car/addCar`, carPayload, {
      headers: { "Content-Type": "application/json" },
    });

    // ✅ בדיקה אם השרת החזיר שגיאה (success: false)
    if (data && data.success === false) {
      setAlertMessage(data.message || data.error || "שגיאה בשמירת הרכב");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    // ✅ ודאי שמהשרת חוזר car_id
    const carId = data?.car_id;
    if (!carId) throw new Error("addCar לא החזיר car_id");

    // ✅ 2) העלאת תמונות (FormData נפרד)
    if (images?.length) {
      const fd = new FormData();
      fd.append("car_id", carId);
      images.forEach((f) => fd.append("images[]", f));
      const uploadRes = await axios.post(`${API_DOMAIN}/car/uploadImages`, fd);
      if (uploadRes.data && uploadRes.data.success === false) {
        setAlertMessage(uploadRes.data.message || uploadRes.data.error || "שגיאה בהעלאת תמונות");
        setAlertType("error");
        setShowAlert(true);
        return;
      }
    }

    // ✅ 3) העלאת וידאו (FormData נפרד)
    if (videoFile) {
      const fdv = new FormData();
      fdv.append("car_id", carId);
      fdv.append("video", videoFile);
      await axios.post(`${API_DOMAIN}/car/uploadVideo`, fdv);
    }

    setAlertMessage("הרכב נשמר בהצלחה");
    setAlertType("success");
    setShowAlert(true);

    onClose();

    // ✅ ניווט עם המשתנה הנכון
    navigate(`provider-cars/${carId}`);
  } catch (err) {
  console.error(err);

  const resData = err?.response?.data;
  const code = resData?.code;
  const msg = resData?.message || resData?.error;

  if (code === "MONTHLY_LIMIT") {
    setAlertMessage(msg || "מוכר פרטי יכול להעלות רכב אחד בלבד בחודש");
    setAlertType("error");
    setShowAlert(true);
    return;
  }

  if (code === "DUPLICATE_LICENSE_FOR_USER") {
    const existingCarId = resData?.car_id;
    const goEdit = existingCarId
      ? () => { onClose(); navigate(`provider-cars/${existingCarId}`); }
      : null;
    setAlertMessage(
      (msg || "כבר קיים רכב עם מספר רישוי זה") +
      (existingCarId ? ` (רכב מספר ${existingCarId})` : "") +
      (goEdit ? " — לחץ 'עריכה' לעבור אליו." : "")
    );
    setAlertType("error");
    setShowAlert(true);
    if (goEdit) {
      // מציג כפתור עריכה בצד ה-Alert — אם תרצי נוכל להוסיף כפתור נפרד
      // לבינתיים: ניווט אוטומטי אחרי 3 שניות
      setTimeout(goEdit, 3000);
    }
    return;
  }

  setAlertMessage(
    msg ||
    (err?.response?.status === 409
      ? "כבר קיים רכב עם מספר רישוי זה"
      : "שגיאה בשמירה")
  );
  setAlertType("error");
  setShowAlert(true);
}

};

  /** ➊ פונקציה גנרית לכל קלט טקסט  */
  const handleCarChange = (e) => {
    setShowAlert(false);
    const { name, value } = e.target;
    setCar((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange = (key) =>
    setForm((prev) => ({ ...prev, [key]: !prev[key] }));

  // Toggle active tab
  // const handleToggle = (tabName) => {
  //   setActiveTab(activeTab === tabName ? null : tabName);
  // };
  const [step, setStep] = useState(1);
  const [selectedSaleTypes, setSelectedSaleTypes] = useState([]); // [1,3]
  const [saleTypeOptions, setSaleTypeOptions] = useState(["לפירוק", "לשיקום"]);

  const toggleTab = (tabIndex) => {
    //alert(tabIndex);

    setActiveTab(activeTab === tabIndex ? null : tabIndex);
  };

  const validateCar = () => {

    setShowAlert(false);

    const validations = [
      { valid: !!car.manufacturer, message: "אנא הזן פרטי רכב" },
      { valid: car.kilometer !== "", message: "אנא הזן קילומטראז'" },
      {
        valid: !isNaN(Number(car.kilometer)) && Number(car.kilometer) >= 0,
        message: "קילומטראז' חייב להיות מספר תקני (0 ומעלה)",
      },
      { valid: car.hand !== "", message: "אנא הזן יד" },
      {
        valid: !isNaN(Number(car.hand)) && Number(car.hand) >= 1,
        message: "אנא הזן ערך תקני עבור שדה: יד"
      },

    ];

    for (let { valid, message } of validations) {
      if (!valid) {
        setAlertMessage(message);
        setAlertType("error");
        setShowAlert(true);
        return;
      }
    }

    setStep(2);

  };

  const nextStep = () => {

    setShowAlert(false);
    setAuctionErrors({});
  if (step === 4 && !car.sale_type_id) {
    setAlertMessage("בחר סוג מכירה");
    setAlertType("error");
    setShowAlert(true);
    return;
  }
    if (step === 4 && car.asking_price === "") {
      setAlertMessage("הזן מחיר");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    if (step === 4 && car.is_auction && (!auctionStartDate || !auctionStartTime)) {
      setAuctionErrors({
        auctionStartDate: !auctionStartDate ? "יש לבחור תאריך התחלה" : "",
        auctionStartTime: !auctionStartTime ? "יש לבחור שעת התחלה" : "",
      });
      setAlertMessage("יש לבחור תאריך ושעת התחלה למכרז");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    if (step < 5) {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleMoveToVideo = () => {

    setShowAlert(false); //alert(images.length);

    if (images.length < 1) {

      setAlertMessage("יש להעלות לפחות תמונה אחת עבור המודעה");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    setStep(3);
  };

const handleLicenseBlur = async (e) => {
  setShowAlert(false);

  const plate = e.target.value.trim();
  if (!plate) return;

  try {
    const { data } = await axios.get(
      `${API_DOMAIN}/car/getCarByIdApi?car_id=${plate}`
    );
    const cd = data?.GetCarByIDResult;

    // שימו לב: ב-API שלכם המזהה האמיתי נקרא CarID, לא id
 if (cd && Object.keys(cd).length > 0 && cd.CarID > 0) {
  setCar((prev) => ({
    ...prev,
    manufacturer: cd.MakerName || "",
    model:        cd.ModelName || "",
    sub_model:    cd.SubModel || "",
    year:         cd.CarYear || "",
    engine_type:  cd.EngineType || "",
    engine_capacity: cd.NefahManoa || "",
    transmission: cd.Transmission || "",
    color:        cd.Color || "",
    gearbox:      cd.Otomat ? "אוטומטי" : "ידני",
    chassis_number: cd.ChassisNumber || "",
    finish_level: cd.RamatGimur || "",
    engine_number: cd.EngineModel || "",
    original_ownership: cd.Owners || "",

    // ✅ אגרת רישוי (קבוצת אגרה)
    annual_registration_fee:
      cd.KvuzatAgra !== null && cd.KvuzatAgra !== undefined ? String(cd.KvuzatAgra) : "",

    // ✅ קילומטראז' (אם -1 אז נשאיר ריק)
    kilometer:
      cd.LastKilometrage !== null &&
      cd.LastKilometrage !== undefined &&
      Number(cd.LastKilometrage) >= 0
        ? String(cd.LastKilometrage)
        : "",
  }));
    const autoAcc = mapAccessoriesFromMot(cd);
  setSelected(autoAcc);
}
else {
      setAlertMessage("לא נמצאו פרטי רכב עבור מספר הרישוי שהוזן.");
      setAlertType("error");
      setShowAlert(true);
setSelected([]);

      setCar((prev) => ({
        ...prev,
        manufacturer: "",
        model:        "",
        sub_model:    "",
        year:         "",
        engine_type:  "",
        engine_capacity: "",
        transmission: "",
        color:        "",
        hand:         "",
        gearbox:      "",
        chassis_number: "",
        finish_level: "",
        engine_number: "",
        kilometer:    "",
        original_ownership: "",
        annual_registration_fee: "",
      }));
    }
  } catch (err) {
    console.error("שגיאה בשליפת נתוני רכב:", err);
  }
};


  const [selected, setSelected] = useState([]);
  const [auctionStartDate, setAuctionStartDate] = useState(null);
  const [auctionStartTime, setAuctionStartTime] = useState('');
  const [auctionErrors, setAuctionErrors] = useState({});

  const selectMultiple = (idsToSelect) => {
    setSelected((prev) => [...new Set([...prev, ...idsToSelect])]);
  };

  const MAX_PRICE_DIGITS = 7; 
const handleAskingPriceChange = (e) => {

  let v = String(e.target.value ?? "").replace(/\D/g, "");

  if (v.length > MAX_PRICE_DIGITS) v = v.slice(0, MAX_PRICE_DIGITS);

  setCar((prev) => ({ ...prev, asking_price: v }));
};

  return (
    <div className="popup-overlay add-new-car-overlay !z-[1000010]">
      {/* רכיב ה־Alert */}
      {showAlert && (
        <Alert
          message={alertMessage}
          type={alertType}
          onClose={() => setShowAlert(false)} // סגירת ההודעה
        />
      )}
      <div className="popup-container">
        {/*<button className="close-btn" onClick={onClose}>
          ×
        </button>*/}
        <div className="left-section-img">
          <img src={sideImage} alt="Car and key" className="car-image" />
          <img src="/images/close-car-pop-icon.svg" alt="close" className="close-car-pop" onClick={onClose} />
        </div>

        {/* Right Section (Steps Content) */}
        <div className="right-section-content">
          {step == 1 && (
            <>
              <div className="popup-content">
                <h2 className="add-car-title">פרטי הרכב</h2>
                <h3 className="sub-title-upload-images">הגדר את הפרטים</h3>

                {/* Breadcrumb Navigation */}

                <div className="header"></div>

                <div
                  className="scrol-wrapper"
                  style={{ height: "calc(100vh - 45vh)" }}
                >
                  <section className="car-details-container mt-6">
                    {/* Tab 1 - פרטי הרכב */}
                    <div className="tab">
                      <>
                        <div
                          onClick={() => toggleTab(1)}
                          style={{
                            backgroundColor: activeTab === 1 ? "#f7f7f7" : "",
                          }}
                          className={`cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
                        >
                          {" "}
                          <div className="flex flex-1 justify-start">
                            <Heading
                              size="ass_20"
                              as="h5"
                              className="text-[20px] font-semibold"
                            >
                              פרטי הרכב
                            </Heading>
                          </div>
                          <Img
                            src={
                              activeTab === index
                                ? `/images/img_checkmark_black_900_03_1.svg`
                                : `/images/img_arrow_left_secondary__primary_white_22x22.svg`
                            }
                            className="h-[22px] self-start"
                          />
                        </div>
                        {activeTab === index && (
                          <div
                            className="flex items-start p-2 md:flex-col"
                            dir="rtl"
                          >
                            <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col"></div>
                            <div className="">
                              <div className="flex justify-end gap-2"></div>
                              <div className="">
                                <div className="tab-content">
                                  <div className="car-details-grid">
                                    <Field
                                      name="license_plate"
                                      label="מס' רישוי"
                                      icon={carIcon}
                                      value={car.license_plate}
                                      onChange={handleCarChange}
                                      onBlur={handleLicenseBlur}
                                    />
                               <Field
                                      name="year"
                                      label="שנת יצור"
                                      icon="/images/img_calendar.svg"
                                      type="number"
                                      value={car.year}
                                      onChange={handleCarChange}
                                    />
                                        <Field
                                      name="kilometer"
                                      label="קילומטראז'"
                                      icon="/images/img_artboard_2_copy_6.svg"
                                      value={car.kilometer}
                                      onChange={handleCarChange}
                                    />
                      
                                  </div>

                                  <div className="car-details-grid">
                                          <Field
                                      name="manufacturer"
                                      label="יצרן"
                                      icon="/images/img_signal_black_900_03_1.svg"
                                      value={car.manufacturer}
                                      onChange={handleCarChange}
                                    />
                                   
                                    <Field
                                      name="sub_model"
                                      label="תת דגם"
                                      icon={carIcon}
                                      value={car.sub_model}
                                      onChange={handleCarChange}
                                    />
                            
                             <Field
                                      name="original_ownership"
                                      label="בעלות מקורית"
                                      icon="/images/img_artboard_2_copy_3_black_900_03_3.svg"
                                      value={car.original_ownership}
                                      onChange={handleCarChange}
                                    />
                           
                             
                                  </div>

                                  <div className="car-details-grid">
                                    <Field
                                      name="model"
                                      label="דגם"
                                      icon={carIcon}
                                      value={car.model}
                                      onChange={handleCarChange}
                                    />
                                    <Field
                                      name="hand"
                                      label="יד"
                                      icon="/images/img_artboard_2_copy_3_black_900_03_3.svg"
                                      value={car.hand}
                                      onChange={handleCarChange}
                                    />
                                                <Field
                                    type="hidden"
                                      name="annual_registration_fee"
                                    //  label="אגרת רישוי"
                                   //   icon="/images/img_calendar.svg"
                                      value={car.annual_registration_fee}
                                      onChange={handleCarChange}
                                    />
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>

                    {/* Tab 2 - מפרט טכני */}
                    <div className="tab">
                      <>
                        <div
                          onClick={() => toggleTab(2)}
                          style={{
                            backgroundColor: activeTab === 2 ? "#f7f7f7" : "",
                          }}
                          className={`cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
                        >
                          {" "}
                          <div className="flex flex-1 justify-start">
                            <Heading
                              size="ass_20"
                              as="h5"
                              className="text-[20px] font-semibold"
                            >
                              מפרט טכני{" "}
                            </Heading>
                          </div>
                          <Img
                            src={
                              activeTab === 2
                                ? `/images/img_checkmark_black_900_03_1.svg`
                                : `/images/img_arrow_left_secondary__primary_white_22x22.svg`
                            }
                            className="h-[22px] self-start"
                          />
                        </div>
                        {activeTab === 2 && (
                          <div
                            className=" p-2 md:flex-col"
                            dir="rtl"
                          >
                            <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col"></div>
                            <div className="">
                              <div className="flex justify-end gap-2"></div>
                              <div className="">
                                <div className="tab-content">
                                  <div className="car-details-grid">
                                             <Field
                                      name="color"
                                      label="צבע"
                                      icon="/images/img_contrast_black_900_03_4.svg"
                                      value={car.color}
                                      onChange={handleCarChange}
                                    />
                                  
                                    <Field
                                      name="finish_level"
                                      label="רמת גימור"
                                      icon="/images/img_signal_black_900_03_1.svg"
                                      value={car.finish_level}
                                      onChange={handleCarChange}
                                    />
                                  
                                  </div>

                                  <div className="car-details-grid">
                                
                                    <Field
                                      name="chassis_number"
                                      label="מס' שילדה"
                                      icon="/images/img_signal_black_900_03_1.svg"
                                      value={car.chassis_number}
                                      onChange={handleCarChange}
                                    />
                                   <Field
                                      name="gearbox"
                                      label="תיבת הילוכים"
                                      icon="/images/gearbox.svg"
                                      value={car.gearbox}
                                      onChange={handleCarChange}
                                    />
          
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>

                    {/*מנוע וביצועים */}
                    {/* Tab 3 -  מנוע וביצועים */}
                    <div className="tab">
                      <>
                        <div
                          onClick={() => toggleTab(3)}
                          style={{
                            backgroundColor: activeTab === 3 ? "#f7f7f7" : "",
                          }}
                          className={`cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
                        >
                          {" "}
                          <div className="flex flex-1 justify-start">
                            <Heading
                              size="ass_20"
                              as="h5"
                              className="text-[20px] font-semibold"
                            >
                              מנוע וביצועים
                            </Heading>
                          </div>
                          <Img
                            src={
                              activeTab === 3
                                ? `/images/img_checkmark_black_900_03_1.svg`
                                : `/images/img_arrow_left_secondary__primary_white_22x22.svg`
                            }
                            className="h-[22px] self-start"
                          />
                        </div>
                        {activeTab === 3 && (
                          <div
                            dir="rtl"
                          >
                            <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col"></div>
                            <div className="">
                              <div className="">
                                <div className="tab-content">
                                  <div className="car-details-grid">
                                 {/*     <Field
                                      name="engine_number"
                                      label="מס' מנוע"
                                      icon={carIcon}
                                      value={car.engine_number}
                                      onChange={handleCarChange}
                                    />*/}
                                    <Field
                                      name="engine_type"
                                      label="סוג מנוע"
                                      icon="/images/img_signal_black_900_03_1.svg"
                                      value={car.engine_type}
                                      onChange={handleCarChange}
                                    />
                                  </div>

                                  <div className="car-details-grid">
                                    <Field
                                      name="engine_capacity"
                                      label="נפח מנוע"
                                      icon="/images/img_signal_black_900_03_1.svg"
                                      value={car.engine_capacity}
                                      onChange={handleCarChange}
                                    />

                                  </div>

                      

                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                      {activeTab === "4" && (
                        <div className="tab-content">
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_signal_black_900_03_1.svg"
                                  alt=""
                                ></img>
                                <label>יצרן</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src={carIcon} alt="hhh"></img>
                                <label>דגם</label>
                              </div>
                              <input type="text" defaultValue="MPD SERENA" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src={carIcon} alt="hhh"></img>
                                <label>תת דגם</label>
                              </div>
                              <input type="text" defaultValue="521154444" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/km-icon.svg" alt="hhh"></img>
                                <label>ק"מ נוכחי</label>
                              </div>
                              <input type="text" defaultValue="521154444" />
                            </div>
                          </div>
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_calendar.svg"
                                  alt="hhh"
                                ></img>
                                <label>שנת יצור</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/engine-icon.svg"
                                  alt="hhh"
                                ></img>
                                <label>מנוע</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_vector_black_900_03_1.svg"
                                  alt="hhh"
                                ></img>
                                <label>גיר</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/gear-icon.svg" alt="hhh"></img>
                                <label>תיבת הילוכים</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                          </div>
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_contrast_black_900_03_4.svg"
                                  alt=""
                                ></img>
                                <label>צבע</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/hand-icon.svg" alt=""></img>
                                <label>יד</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/hand-icon.svg" alt=""></img>
                                <label>בעלות מקורית</label>
                              </div>
                              <input type="text" defaultValue="" />
                            </div>
                 
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Tab 4 - אבזור ונוחות*/}
                    <div className="tab">
                      <>
                        <div
                          onClick={() => toggleTab(4)}
                          style={{
                            backgroundColor: activeTab === 4 ? "#f7f7f7" : "",
                          }}
                          className={`cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
                        >
                          {" "}
                          <div className="flex flex-1 justify-start">
                            <Heading
                              size="ass_20"
                              as="h5"
                              className="text-[20px] font-semibold"
                            >
                              אבזור ונוחות
                            </Heading>
                          </div>
                          <Img
                            src={
                              activeTab === 4
                                ? `/images/img_checkmark_black_900_03_1.svg`
                                : `/images/img_arrow_left_secondary__primary_white_22x22.svg`
                            }
                            className="h-[22px] self-start"
                          />
                        </div>
                        {activeTab === 4 && (
                          <div
                            className="flex items-start p-2 md:flex-col"
                            dir="rtl"
                          >
                            <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col"></div>
                            <div className="flex justify-end gap-2"></div>
                            <div className="tab-content">
                              <AccesoriesCheckList selected={selected} setSelected={setSelected} />
                            </div>
                          </div>
                        )}
                      </>
                      {activeTab === "carDetails" && (
                        <div className="tab-content">
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src={carIcon} alt="hhh"></img>
                                <label>מס' רישוי</label>
                              </div>
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_signal_black_900_03_1.svg"
                                  alt=""
                                ></img>
                                <label>יצרן</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src={carIcon} alt="hhh"></img>
                                <label>דגם</label>
                              </div>
                              <input type="text" defaultValue="MPD SERENA" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src={carIcon} alt="hhh"></img>
                                <label>תת דגם</label>
                              </div>
                              <input type="text" defaultValue="521154444" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/km-icon.svg" alt="hhh"></img>
                                <label>ק"מ נוכחי</label>
                              </div>
                              <input type="text" defaultValue="521154444" />
                            </div>
                          </div>
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_calendar.svg"
                                  alt="hhh"
                                ></img>
                                <label>שנת יצור</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/engine-icon.svg"
                                  alt="hhh"
                                ></img>
                                <label>מנוע</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_vector_black_900_03_1.svg"
                                  alt="hhh"
                                ></img>
                                <label>גיר</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/gear-icon.svg" alt="hhh"></img>
                                <label>תיבת הילוכים</label>
                              </div>
                              <input type="text" defaultValue="2002" />
                            </div>
                          </div>
                          <div className="car-details-grid">
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img
                                  src="images/img_contrast_black_900_03_4.svg"
                                  alt=""
                                ></img>
                                <label>צבע</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/hand-icon.svg" alt=""></img>
                                <label>יד</label>
                              </div>
                              <input type="text" defaultValue="רובר אנגליה" />
                            </div>
                            <div class="wrp-car-field">
                              <div className="label-wrap">
                                <img src="images/hand-icon.svg" alt=""></img>
                                <label>בעלות מקורית</label>
                              </div>
                              <input type="text" defaultValue="" />
                            </div>
                       
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Tab 5 - מידע על העסקה */}
                  {/*  <div className="tab">
                      <>
                        <div
                          onClick={() => toggleTab(5)}
                          style={{
                            backgroundColor: activeTab === 5 ? "#f7f7f7" : "",
                          }}
                          className={`cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
                        >
                          {" "}
                          <div className="flex flex-1 justify-start">
                            <Heading
                              size="ass_20"
                              as="h5"
                              className="text-[20px] font-semibold"
                            >
                              מידע על העסקה
                            </Heading>
                          </div>
                          <Img
                            src={
                              activeTab === 5
                                ? `/images/img_checkmark_black_900_03_1.svg`
                                : `/images/img_arrow_left_secondary__primary_white_22x22.svg`
                            }
                            className="h-[22px] self-start"
                          />
                        </div>
                        {activeTab === 5 && (
                          <div
                            className="flex items-start p-2 md:flex-col"
                            dir="rtl"
                          >
                            <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col"></div>
                            <div className="">
                              <div className="flex justify-end gap-2"></div>
                              <div className="">
                                <div className="tab-content">
                                  <div className="car-details-grid">
                             
                                    <Field
                                      name="entry_date"
                                      label="תאריך כניסה"
                                      icon="images/img_calendar.svg"
                                      type="date"
                                      value={car.entry_date}
                                      onChange={(date) => setCar((prev) => ({ ...prev, entry_date: date }))}                                     
                                      onBlur={() => { }}
                                    />
                                    <Field
                                      name="manufacturer"
                                      label="אחריות מהסוכנות"
                                      icon="images/img_signal_black_900_03_1.svg"
                                    />
                                    <Field
                                      name="model"
                                      label="התחייבות"
                                      icon={carIcon}
                                    />
                                  </div>

                                  <div className="car-details-grid">
                          
                                    <Field
                                      name="pickup_date"
                                      label="תאריך איסוף"
                                      icon="images/img_calendar.svg"
                                      type="date"
                                      value={car.pickup_date}
                                      onChange={(date) => setCar((prev) => ({ ...prev, pickup_date: date }))}                                     
                                      onBlur={() => { }}
                                    />
                                    <Field
                                      name="kilometer"
                                      label="התחיבות לבדיקת"
                                      icon="images/km-icon.svg"
                                    />
                                  </div>

                                  <div className="car-details-grid">
                                    <Field
                                      name="insert_date"
                                      label="מיקום העסקה"
                                      icon="images/img_calendar.svg"                                    
                                    />
                            
                                    <Field
                                      name="last_payment_date"
                                      label="תאריך תשלום אחרון"
                                      icon="images/img_calendar.svg"
                                      type="date"
                                      value={car.last_payment_date}
                                      onChange={(date) => setCar((prev) => ({ ...prev, last_payment_date: date }))}                                     
                                      onBlur={() => { }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>*/}
                    {/*jjjj*/}
                  </section>
                </div>

                <div
                  style={{ zIndex: "99" }}
                  onClick={() => validateCar()}
                  className="flex items-center justify-center gap-4 popup-footer"
                >
                  {/* כפתור הבא / סיום */}
                  {step > 1 && (
                    <button
                      onClick={onClose}
                      type="button"
                      className="flex items-center gap-1 rounded-full border border-gray-400 px-4 py-2 text-sm font-semibold"
                    >
                      {" "}
                      <span className="text-lg leading-none">‹</span>
                      קודם
                    </button>
                  )}
                  {step < 5 ? (
                    <button
                      // onClick={nextStep}

                      type="button"
                      style={{ color: "white" }}
                      className="flex items-center gap-1 rounded-full bg-red-600 px-4 py-2 text-white text-sm font-semibold"
                    >
                      <span className="text-lg leading-none">‹</span>
                      הבא
                    </button>
                  ) : (
                    <button
                      // onClick={prevStep}
                      onClick={() => setStep(2)}
                      type="button"
                      className="flex items-center gap-1 rounded-full bg-red-600 px-6 py-1.5 text-white text-sm font-semibold"
                    >
                      <span className="text-lg leading-none">‹</span>
                      סיום
                    </button>
                  )}

                  {/* כפתור קודם (מוצג רק אם step > 1) */}
                </div>
              </div>
            </>
          )}

          {step == 2 && (
            <div
              dir="rtl"
              className="min-h-screen bg-white flex flex-col items-center py-5 px-4"
            >
              {/* Header */}
              <h2 className="add-car-title">העלאת תמונות רכבים</h2>
              <h3 className="sub-title-upload-images">צלם ותעלה לגלריה</h3>
              <p className="text-xs text-gray-600 mb-2">גררו כדי לשנות סדר. תמונה מספר 1 היא התמונה הראשית.</p>

              {/* Image Grid + Upload Card */}
       <div className="w-full flex flex-row gap-6 py-10">
  {/* אזור DnD + קליק */}
  <label
    className={`w-1/3 border rounded-lg p-6 flex flex-col items-center justify-center upload-area2 cursor-pointer transition
      ${isDragging ? "drag-over" : ""}
    `}
    onDragOver={handleDragOver}
    onDragEnter={handleDragEnter}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
  >
    <input
      type="file"
      accept="image/jpeg,image/png,image/svg+xml"
      multiple
      className="hidden"
      onChange={handleFileChange}
    />

    <b>גררו או לחצו על התיבה כדי להוסיף תמונות</b>
    <div className="mb-2 mt-3">
      <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 16l4-5h-3V4h-2v7H8z" />
        <path d="M5 20h14v-2H5z" />
      </svg>
    </div>
    <p className="text-xs text-red-500 text-center">
      עד {MAX_IMAGE_SIZE_KB}KB, סוגי קבצים: JPEG, PNG, SVG (מקסימום {MAX_IMAGES} תמונות)
    </p>
  </label>

  {/* תצוגת התמונות */}
  <div className="grid grid-cols-3 gap-1 flex-1" style={{ maxHeight: '32vh', overflowY: 'auto' }}>
    {images.map((img, i) => (
      <div
        key={i}
        style={{ height: '15vh', position: 'relative', background: '#e5e7eb', overflow: 'hidden' }}
        draggable
        onDragStart={() => handleImageDragStart(i)}
        onDragOver={(e) => e.preventDefault()}
        onDrop={() => handleImageDropReorder(i)}
        onDragEnd={handleImageDragEnd}
      >
        <img
          src={typeof img === 'string' ? img : URL.createObjectURL(img)}
          alt={`img-${i}`}
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
        />
        {/* מספר סידורי */}
        <div style={{position:'absolute',top:4,left:4,zIndex:20,width:24,height:24,borderRadius:'50%',background:'#1e3a5f',color:'#fff',fontSize:11,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 1px 3px rgba(0,0,0,.3)'}}>
          {i + 1}
        </div>
        {/* ידית גרירה */}
        <div style={{position:'absolute',top:4,left:'50%',transform:'translateX(-50%)',zIndex:20}}>
          <div style={{width:28,height:28,borderRadius:'50%',background:'rgba(255,255,255,0.95)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'move',boxShadow:'0 1px 3px rgba(0,0,0,.25)',border:'1px solid #d1d5db'}}>
            <svg viewBox="0 0 24 24" style={{width:14,height:14}} fill="none"><path d="M8 5v14M12 5v14M16 5v14" stroke="#555" strokeWidth="2" strokeLinecap="round"/></svg>
          </div>
        </div>
        {/* כוכב – תמונה ראשית */}
        <div style={{position:'absolute',top:4,right:4,zIndex:20}}>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); handleSetAsPrimaryImage(i); }}
            style={{width:28,height:28,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',boxShadow:'0 1px 3px rgba(0,0,0,.25)',background: i === 0 ? '#fbbf24' : 'rgba(255,255,255,0.95)',border: i === 0 ? '2px solid #f59e0b' : '1px solid #d1d5db',padding:0,outline:'none'}}
            title={i === 0 ? 'תמונה ראשית' : 'קבע כתמונה ראשית'}
          >
            <svg viewBox="0 0 24 24" style={{width:16,height:16}} fill={i === 0 ? '#fff' : 'none'}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke={i === 0 ? '#fff' : '#6b7280'} strokeWidth="2" strokeLinejoin="round"/></svg>
          </button>
        </div>
        {/* סיבוב + מחיקה */}
        <div style={{position:'absolute',bottom:4,left:4,zIndex:20,display:'flex',alignItems:'center',gap:6}}>
          <button
            type="button"
            onClick={() => handleRotateImage(i)}
            disabled={rotatingIndexes.includes(i)}
            style={{width:28,height:28,borderRadius:8,border:'1px solid #e5e7eb',background:'#fff',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',boxShadow:'0 1px 2px rgba(0,0,0,.15)'}}
            title="סובב תמונה"
          >
            <RotateIcon />
          </button>
          <button
            type="button"
            onClick={() => handleDelete(i)}
            style={{width:28,height:28,borderRadius:8,border:'1px solid #e5e7eb',background:'#fff',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',boxShadow:'0 1px 2px rgba(0,0,0,.15)',padding:0}}
            title="מחק תמונה"
          >
            <svg viewBox="0 0 24 24" style={{width:14,height:14}} fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
          </button>
        </div>
      </div>
    ))}


  </div>
</div>


              <div className="flex items-center justify-center gap-4 popup-footer">
                {/* כפתור הבא / סיום */}
                <button
                  onClick={() => {
                    setStep(1);
                  }}
                  type="button"
                  className="flex items-center gap-1 rounded-full border border-gray-400 px-4 py-2 text-sm font-semibold"
                >
                  {" "}
                  <span className="text-lg leading-none">‹</span>
                  קודם
                </button>

                {
                  <button
                    onClick={() => {
                      //setStep(3);
                      handleMoveToVideo();
                    }}
                    type="button"
                    style={{ color: "white" }}
                    className="flex items-center gap-1 rounded-full bg-red-600 px-4 py-2 text-white text-sm font-semibold"
                  >
                    הבא <span className="text-lg leading-none">›</span>
                  </button>
                }

                {/* כפתור קודם (מוצג רק אם step > 1) */}
              </div>

              {/* Progress Bar */}
            </div>
          )}

          {/*step 3 */}
          {step == 3 && (
            <div
              dir="rtl"
              className="min-h-screen bg-white flex flex-col items-center py-5 px-4"
            >
              {/* Header */}
              <h2 className="add-car-title">העלאת וידאו רכבים</h2>
              <h3 className="sub-title-upload-images">צלם ותעלה לגלריה</h3>

              {/* Image Grid + Upload Card */}
              <div className="w-full flex flex-row py-10">
<label
  className={`w-1/3 border border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center upload-area2 cursor-pointer transition
    ${isDraggingVideo ? "drag-over" : ""}
  `}
  onDragOver={handleVideoDragOver}
  onDragEnter={handleVideoDragEnter}
  onDragLeave={handleVideoDragLeave}
  onDrop={handleVideoDrop}
>
  <input
    type="file"
    accept="video/mp4,video/quicktime,video/x-m4v,video/avi,video/x-msvideo,video/mpeg,video/*"
    className="hidden"
    onChange={handleVideoChange}
  />

  <b>גררו או לחצו כדי להוסיף וידאו</b>
  <div className="mb-2 mt-3">
    <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 16l4-5h-3V4h-2v7H8z" />
      <path d="M5 20h14v-2H5z" />
    </svg>
  </div>
  <p className="text-xs text-red-500 text-center">
    עד {MAX_VIDEO_SIZE_MB}MB, סוגי קבצים מומלצים: MP4, MOV, AVI, MPEG
  </p>
</label>

                {/* Placeholder grid */}
                <div className="grid gap-1 flex-1">
                  <div
                    className="relative bg-gray-200"
                    style={{ height: "32vh" }}
                  >
                    <div className="flex justify-center items-center h-full w-full">
                      {videoFile ? (
                        <video
                          controls
                          src={URL.createObjectURL(videoFile)}
                          className="w-full h-full object-cover rounded"
                        />
                      ) : (
                        <img
                          src="/images/viedio-icon.svg"
                          alt="video placeholder"
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Upload card */}
              </div>

              <div className="flex items-center justify-center gap-4 popup-footer">
                {/* כפתור הבא / סיום */}
                {step > 1 && (
                  <button
                    onClick={() => {
                      setStep(2);
                    }}
                    type="button"
                    className="flex items-center gap-1 rounded-full border border-gray-400 px-4 py-2 text-sm font-semibold"
                  >
                    {" "}
                    <span className="text-lg leading-none">‹</span>
                    קודם
                  </button>
                )}
                {step < 5 ? (
                  <button
                    onClick={() => {
                      setStep(4);
                    }}
                    type="button"
                    style={{ color: "white" }}
                    className="flex items-center gap-1 rounded-full bg-red-600 px-4 py-2 text-white text-sm font-semibold"
                  >
                    הבא <span className="text-lg leading-none">›</span>
                  </button>
                ) : (
                  <button
                    onClick={prevStep}
                    type="button"
                    className="flex items-center gap-1 rounded-full bg-red-600 px-6 py-1.5 text-white text-sm font-semibold"
                  >
                    <span className="text-lg leading-none">‹</span>
                    סיום
                  </button>
                )}

                {/* כפתור קודם (מוצג רק אם step > 1) */}
              </div>

              {/* Progress Bar */}
            </div>
          )}

          {/*step 4* */}

          {step == 4 && (
            <div className="popup-content" dir="rtl">
              <h2 className="add-car-title">מחיר ופרטים נוספים</h2>
              <h3 className="sub-title-upload-images">הגדר את הפרטים</h3>

              <div dir="rtl" className="m-9">
<div className="flex items-center justify-center gap-6">
  <span className="text-sm font-medium">מיועד&nbsp;ל</span>

  {/* לפרוק */}
  <label className="checkbox-item cursor-pointer select-none" style={{width:'auto'}}>
    {/* קלט חבוי (רדיו) */}
    <input
      type="radio"
      name="sale_type"
      value="unload"
      checked={form.saleTypes[0] === "unload"}
      onChange={() => toggleSaleType("unload")}
    />
    {/* ריבוע עם וי – כמו בפילטר בר */}
    <span
      className={
        "custom-checkbox" +
        (form.saleTypes[0] === "unload" ? " checked" : "")
      }
      aria-hidden
    />
    <span className="text-sm">לפרוק</span>
  </label>

  {/* לשיקום */}
  <label className="checkbox-item cursor-pointer select-none" style={{width:'auto'}}>
    <input
      type="radio"
      name="sale_type"
      value="marketing"
      checked={form.saleTypes[0] === "marketing"}
      onChange={() => toggleSaleType("marketing")}
    />
    <span
      className={
        "custom-checkbox" +
        (form.saleTypes[0] === "marketing" ? " checked" : "")
      }
      aria-hidden
    />
    <span className="text-sm">לשיקום</span>
  </label>
</div>


                {/* סמל מידע + מתג */}
                {/* <div className="flex items-center justify-center gap-3 m-5">
                  <span className="text-sm font-medium">יעלה&nbsp;כמכרז</span>                  
                  <Switch
                    checked={!car.is_auction} // ימין ⇒ false
                    onCheckedChange={(val) =>  // ימני = true 
                      setCar((prev) => ({ ...prev, is_auction: !val }))
                    }
                  />
                  <span className="text-gray-500 text-lg leading-none">ⓘ</span>
                </div>*/}

                {/* שדה קלט מחיר פינוי */}
                <div className="flex flex-row-reverse items-center gap-3 justify-center w-fit mx-auto m-5">
<input
  id="asking_price"
  name="asking_price"
  type="number"
  dir="ltr"
  value={car.asking_price}
  onChange={handleAskingPriceChange}
  inputMode="numeric"
  className="w-40 rounded border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
/>


                  <label
                    htmlFor="price"
                    className="text-sm font-medium shrink-0 whitespace-nowrap"
                  >
                    מחיר
                  </label>
                </div>

                {/* Auction fields (מחיר ופרטים נוספים) */}
                <div className="m-5">
                  <AuctionFormFields
                    isAuction={!!car.is_auction}
                    auctionStartDate={auctionStartDate}
                    auctionStartTime={auctionStartTime}
                    onAuctionToggle={() => {
                      setCar((prev) => ({ ...prev, is_auction: !prev.is_auction }));
                      setAuctionStartDate(null);
                      setAuctionStartTime('');
                      setAuctionErrors({});
                      setShowAlert(false);
                    }}
                    onAuctionDateChange={(v) => {
                      setAuctionStartDate(v);
                      setAuctionErrors((prev) => ({ ...prev, auctionStartDate: "" }));
                    }}
                    onAuctionTimeChange={(v) => {
                      setAuctionStartTime(v);
                      setAuctionErrors((prev) => ({ ...prev, auctionStartTime: "" }));
                    }}
                    errors={auctionErrors}
                  />
                </div>

                {/* כפתורי ניווט */}

                <div className="flex items-center justify-center gap-4 popup-footer">
                  {/* כפתור הבא / סיום */}
                  {step > 1 && (
                    <button
                      onClick={() => setStep(3)}
                      type="button"
                      className="flex items-center gap-1 rounded-full border border-gray-400 px-4 py-2 text-sm font-semibold"
                    >
                      {" "}
                      <span className="text-lg leading-none">‹</span>
                      קודם
                    </button>
                  )}
                  {step < 5 ? (
                    <button
                      onClick={nextStep}
                      type="button"
                      style={{ color: "white" }}
                      className="flex items-center gap-1 rounded-full bg-red-600 px-4 py-2 text-white text-sm font-semibold"
                    >
                      הבא <span className="text-lg leading-none">›</span>
                    </button>
                  ) : (
                    <button
                      onClick={prevStep}
                      type="button"
                      className="flex items-center gap-1 rounded-full bg-red-600 px-6 py-1.5 text-white text-sm font-semibold"
                    >
                      <span className="text-lg leading-none">‹</span>
                      סיום
                    </button>
                  )}

                  {/* כפתור קודם (מוצג רק אם step > 1) */}
                </div>
              </div>

              {/* Checkboxes */}

              {/* Breadcrumb Navigation */}

              <div className="header"></div>
            </div>
          )}

          {/*step 5 */}

          {step == 5 && (
            <div className="popup-content" dir="rtl">
              <h2 className="add-car-title">סיכום מסמך</h2>
              <h3 className="sub-title-upload-images">
                כל הפרטים על המודעת רכב החדשה
              </h3>
              <div className="flex justify-center mt-3">
                <div className="w-[30%] flex justify-center" style={{ display: "flex", justifyContent: "center" }}>
                  {
                    // compute preview auction datetime from local state if present
                  }
                  <CarSummaryPreview
                    {...car}
                    {...getPreviewAuctionFields()}
                    images={images}
                    offered_price={car.asking_price}
                  />
                </div>
              </div>
              <div className="flex items-center justify-center gap-4 popup-footer">
                {/* כפתור הבא / סיום */}
                {step > 1 && (
                  <button
                    onClick={() => setStep(4)}
                    type="button"
                    className="flex items-center gap-1 rounded-full border border-gray-400 px-4 py-2 text-sm font-semibold"
                  >
                    {" "}
                    <span className="text-lg leading-none">‹</span>
                    קודם
                  </button>
                )}

                <button
                  // onClick={prevStep}
                  onClick={handleSubmit} // ← כאן הבקשה ל-DB
                  type="button"
                  style={{ color: "white" }}
                  className="flex items-center gap-1 rounded-full bg-red-600 px-6 py-2 text-white text-sm font-semibold"
                >
                  שמור וסיים
                  <span className="text-lg leading-none text-white">›</span>
                </button>

                {/* כפתור קודם (מוצג רק אם step > 1) */}
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              position: "absolute",
              bottom: "0",
              maxWidth: "90%",
              pointerEvents: "none",
            }}
          >
            <img src={`/images/step${step}.svg`} alt={`שלב ${step}`} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewCar;
